import { useContext } from 'react';
import { useMentorsContext } from '../../contexts/mentors-context';
import { UserContext } from '../../contexts/user-context';
import { Dialog } from '../common';
import AssignMentorsForm from '../forms/assign-mentors';

function MentorAssignModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    assignTargetMentor,
    isAssigningMentor,
    loadedVenturesById,
    handleVenturesLoaded,
    handleAssingSuccessForm,
    setAssignTargetMentor,
  } = useMentorsContext();

  return hasAccessToAction('mentor.details.update') && !!assignTargetMentor ? (
    <Dialog
      open={true}
      setOpen={() => setAssignTargetMentor(null)}
      title='New assignment'
      caption={`${assignTargetMentor.firstName} ${assignTargetMentor.lastName}`}
      contentRenderer={({ handleClose }) => (
        <AssignMentorsForm
          mentorId={assignTargetMentor.id}
          loading={isAssigningMentor[assignTargetMentor.id]}
          onLoaded={handleVenturesLoaded(assignTargetMentor.id)}
          ventures={loadedVenturesById[assignTargetMentor.id]}
          onSuccess={handleAssingSuccessForm(
            assignTargetMentor.id,
            handleClose,
          )}
          onCancel={handleClose}
        />
      )}
      width={720}
    />
  ) : null;
}

export default MentorAssignModal;
